import { Store } from '@tanstack/store';

interface AppDataState {
  userCurrentAddress: string | null;
  isContextSwitching: boolean;
  selectedOrganization?: {
    name: string;
    uuid: string;
  } | null;
  selectedClientGroup?: {
    name: string;
    uuid: string;
  } | null;
}

const initialState: AppDataState = {
  userCurrentAddress: null,
  isContextSwitching: false,
  selectedClientGroup: null,
  selectedOrganization: null,
};

export const appDataStore = new Store<AppDataState>(initialState);

export const setAppDataStore = (newState: Partial<AppDataState>) => {
  appDataStore.setState(state => ({
    ...state,
    ...newState,
  }));
};
